import React from 'react'

import { connect } from 'react-redux'
import { Item, Box } from 'react-html-email';

import Row from "./row"

class Header extends React.Component {

  render() {
    const headerContent = this.props.header.map((content, index) => (
      <Item key={index} align={content.align}>
        <Row content={content} html={this.props.html} section="header" index={index}/>
      </Item>
    ));

    return (
      <Box width="100%" >
        {headerContent}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
    header: state.design.header,
    folder: state.design.folder
  }
}

export default connect(
  mapStateToProps
)(Header)